
var fullCustomerData='';
 const newDesktopImg = "https://cdn.shopify.com/s/files/1/0675/1964/3847/files/159X40_Logo.png?v=1765974561";
  const newMobileImg  = "https://cdn.shopify.com/s/files/1/0675/1964/3847/files/159X40_Logo.png?v=1765974561&width=320";

  const $logo = $('.header__logo picture');
   
  // Update <img>
  $logo.find('img')
    .attr('src', newDesktopImg)
    .attr('srcset', newDesktopImg);

  // Update <source> (mobile)
  $logo.find('source')
    .attr('srcset', newMobileImg);
  $('.main-menu').html('');



function loadAgChimpMenu() {
  console.log('loading menu');
console.log('data',customerData);
  if(customerData != null){
    var arr = customerData.tags;

  if ($.inArray("wholesale", arr) !== -1) {
    isB2B = true;
  $('.retail-customer').addClass('d-none');
  $('.b2b-customer').removeClass('d-none');
  $('.account-row').addClass('b2bAccount');
  } else {
      $('.retail-customer').removeClass('d-none');
  $('.b2b-customer').addClass('d-none');
    $('.account-row').addClass('retailAccount');
  }
   var data = {
    "id":"gid://shopify/Customer/" + customerData.id
  }
  fullCustomerData = graphQuery(getFullCustomer,data)
  console.log(fullCustomerData)
    if(fullCustomerData.data.customer.hasOwnProperty('metafield') && fullCustomerData.data.customer.metafield !== null){
    if(fullCustomerData.data.customer.metafield.key==="company_name"){
      $('.account-greeting').html(fullCustomerData.data.customer.metafield.value);
      $('#customerSince').html(formatDateMMDDYYYY(fullCustomerData.data.customer.createdAt));
      $('.account_type').html("Wholesale");
    }
  }
  $('.account-inline').removeClass('d-none')
}
console.log('customerData is null')
console.log(localStorage['agchimpToken'])
var tokenData = JSON.parse(localStorage['agchimpToken']);

     var settings = {
    url: localStorage["apiBaseUrl"] + "/api/DynamicDb/CallSp",
    method: "POST",
    timeout: 0,
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + tokenData.token,
    },
    data: JSON.stringify({
      storedProcedureName: 'shopify_fetch_menu_s',
           procReturnsJson: true,
    }),
 
  };

  $.ajax(settings)
    .done(function (response) {
         localStorage.setItem('mainMenu',JSON.stringify(response));
        buildMenu();
    }).fail(function(error){
        console.log(error)
    })

}
function buildMenu(){

  var menuData=JSON.parse(localStorage['mainMenu']);

  /* =========================
     INJECT MENU
  ========================= */
  const agcCustomMenu = `
  <nav class="agc-nav">
    <ul class="agc-menu">

      <li class="agc-menu-item has-mega">
        <a href="#" class="agc-menu-link agc-toggle">Products ▾</a>

        <div class="agc-mega">

          <ul class="agc-submenu">
            <li data-panel="mole"><a href="#">Mole Repellents</a></li>
            <li data-panel="vole"><a href="#">Vole Repellents</a></li>
            <li data-panel="granular"><a href="#">Granular Products</a></li>
            <li data-panel="liquid"><a href="#">Liquid Sprays</a></li>
          </ul>

          <div class="agc-panels">

            <div class="agc-panel" id="panel-mole">
              <a href="/products/burrowbloc" class="agc-card-menu">
                <img src="" alt="">
                <h4>BurrowBloc</h4>
                <span>$24.99</span>
              </a>
            </div>

            <div class="agc-panel" id="panel-vole">
              <a href="/products/vole-guard" class="agc-card-menu">
                <h4>Vole Guard</h4>
                <span>$21.99</span>
              </a>
            </div>

            <div class="agc-panel" id="panel-granular">
              <a href="/collections/granular-products" class="agc-card-menu">
                <h4>View All Granular Products</h4>
              </a>
            </div>

            <div class="agc-panel" id="panel-liquid">
              <a href="/collections/liquid-sprays" class="agc-card-menu">
                <h4>View All Liquid Sprays</h4>
              </a>
            </div>

          </div>
        </div>
      </li>

    </ul>
  </nav>
  `;


var explodedMenuItem='';

$.each(menuData,function(){
    var subLinks = '';
    var subMenuLinks='';
    
    if(this.hasOwnProperty('subMenus')){
        
        $.each(this.subMenus,function(){
           var childElements='';
        var completeChildElements = '';
             if(this.hasOwnProperty('childMenus')){
                
                $.each(this.childMenus,function(){
                    var grandchildrenElements='';
                var completegrandchildElements = '';
                    if(this.hasOwnProperty('grandchildMenus')){
                        $.each(this.grandchildMenus,function(){
                                grandchildrenElements +=` <li class="agc-subSubSubmenu-item subsubhas-icon"><a href="/collections/`+this.handle+`">
                                <span class="submenu-icon"><img src="`+this.image+`" alt="`+this.name+`"></span>
                                <span class="submenu-text">`+this.name+`</span>
                                </a></li>`;
                        })
                            completegrandchildElements = `<ul class="agc-subsubsubmenu">`+grandchildrenElements+`</ul>`;
                    }
                childElements +=` <li class="agc-subSubmenu-item subsubhas-icon"><a href="/collections/`+this.handle+`">
                <span class="submenu-icon"><img src="`+this.image+`" alt="`+this.name+`"></span>
            <span class="submenu-text">`+this.name+`</span>
                </a>`+completegrandchildElements+`</li>`;
                })
                completeChildElements = `<ul class="agc-subsubmenu">`+childElements+`</ul>`;
        
                }
            subLinks +=`
            <li class="agc-submenu-item has-children has-icon"><a href="/collections/`+this.handle+`">
            <span class="submenu-icon"><img src="`+this.image+`" alt="`+this.name+`"></span>
            <span class="submenu-text">`+this.name+`</span>
            </a>`+completeChildElements+`</li>`;
        })
        
        subMenuLinks = `<div class="agc-mega"><ul class="agc-submenu">` + subLinks + `</ul></div>`;
        
    }

    showTickTrue = '<i class="fa-jelly fa-regular fa-angle-down"></i>';
    showTickFalse='';
    if(this.hasOwnProperty('path')){
                        explodedMenuItem += `<li class="agc-menu-item has-mega">
        <a href="`+this.path+`" class="agc-menu-link">`+this.name+`</a>`+subMenuLinks+`</li>`;
            } else {
                        explodedMenuItem += `<li class="agc-menu-item has-mega">
        <a href="#" class="agc-menu-link agc-toggle">`+this.name+` `+showTickTrue+`</a>`+subMenuLinks+`</li>`;
    }
    
})



  document.querySelector('.agc-main-menu').innerHTML = ` <button class="agc-hamburger  vl-btn"  aria-label="Open menu" aria-expanded="false">
  <i class="fa-solid fa-bars"></i>
  <span></span>
  <span></span>
  <span></span>
</button><nav class="agc-nav"><button class="agc-menu-close" aria-label="Close menu">✕</button> <ul class="agc-menu">` + explodedMenuItem + `</ul></nav>`;
const closeBtn = document.querySelector('.agc-menu-close');
const agcNav = document.querySelector('.agc-nav');
const hamburger = document.querySelector('.agc-hamburger');

function closeAgcMenu() {
  agcNav.classList.remove('open');
  hamburger.classList.remove('active');
  hamburger.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('agc-menu-open');
}

if (closeBtn) {
  closeBtn.addEventListener('click', closeAgcMenu);
}

if (hamburger && agcNav) {
  hamburger.addEventListener('click', () => {
    const isOpen = agcNav.classList.toggle('open');

    hamburger.classList.toggle('active', isOpen);
    hamburger.setAttribute('aria-expanded', isOpen);
    document.body.classList.toggle('agc-menu-open', isOpen);
  });
}



document.querySelectorAll('.has-mega').forEach(megaItem => {
  const toggle = megaItem.querySelector('.agc-toggle');

  if (!toggle) return;

  toggle.addEventListener('click', e => {
    e.preventDefault();       // only stops #
    e.stopPropagation();

    document.querySelectorAll('.has-mega.open').forEach(item => {
      if (item !== megaItem) item.classList.remove('open');
    });

    megaItem.classList.toggle('open');
  });
});

  /* =========================
     CLOSE ON OUTSIDE CLICK
  ========================= */
  document.addEventListener('click', () => {
    document.querySelectorAll('.has-mega.open')
      .forEach(item => item.classList.remove('open'));
  });



};

function canHover() {
  return window.matchMedia('(hover: hover)').matches;
}

document.querySelectorAll('.has-mega').forEach(megaItem => {
  const toggle = megaItem.querySelector('.agc-toggle');
  if (!toggle) return;

  toggle.addEventListener('click', e => {

    // If device cannot hover (touch screens, tablets, phones)
    if (!canHover()) {
      e.preventDefault();
      e.stopPropagation();

      document.querySelectorAll('.has-mega.open').forEach(item => {
        if (item !== megaItem) item.classList.remove('open');
      });

      megaItem.classList.toggle('open');
    }
  });
});



